import React, { useState, useEffect } from 'react';

import styles from './jobs.module.scss';
import UserLayout from '../../components/user-layout/UserLayout';
import { NavLink, useNavigate } from 'react-router-dom';
import jobService from '../../utils/services/jobService';
import authService from '../../utils/services/authService';

const Jobs = () => {
  const [jobs, setJobs] = useState([]);
  const [query, setQuery] = useState();
  const [hasSearched, setHasSearched] = useState(false);

  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);

  const userData = authService.getUserData();

  const navigate = useNavigate();

  useEffect(() => {
    /* clear address field on reload page, (what's a better way?) */
    if (!query) {
      navigate('/jobs');
    }
  }, []);

  useEffect(() => {
    const response = jobService.getAllJobs(page, userData).then((res) => {
      if (res.data.success) {
        setJobs(res.data.data.jobs);
        setPageCount(res.data.data.pagination.pageCount);
      }
    });
  }, [page]);

  useEffect(() => {
    if (hasSearched) {
      const response = jobService.searchJob(page, query).then((res) => {
        if (res.data.success) {
          setJobs(res.data.data.jobs);
          setPageCount(res.data.data.pagination.pageCount);
        }
      });
    }
  }, [hasSearched]);

  const handlePrevious = () => {
    setPage((page) => {
      if (page === 1) return page;

      return page - 1;
    });
  };

  const handleNext = () => {
    setPage((page) => {
      if (page === pageCount) return page;

      return page + 1;
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (!query) {
      navigate('/jobs');
      setHasSearched(false);
    } else {
      setHasSearched(true);

      const result = jobService.searchJob(page, query).then((res) => {
        if (res.data.success) {
          setJobs(res.data.data.jobs);
          setPageCount(res.data.data.pagination.pageCount);
        }
      });
    }
  };
  return (
    <UserLayout>
      <section className={styles.jobsWrapper}>
        <section className={styles.search}>
          <form className={styles.searchForm}>
            <h2 className={styles.searchForm_heading}>
              Find your new job today!
            </h2>
            <div className={styles.formGroup}>
              <span className={styles.inputExplanation}>What</span>
              <input
                id="query"
                type="text"
                name="query"
                aria-label="Search field"
                placeholder="keywords, role or location"
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
              <img
                className={styles.searchIcon}
                src={require('../../assets/images/search-icon.png')}
                alt=""
              />
            </div>

            <div className={styles.formGroup}>
              <button
                type="submit"
                className={styles.formBtn}
                onClick={(e) => {
                  submitHandler(e);
                }}
              >
                Search jobs
              </button>
            </div>
          </form>
        </section>
        <section className={styles.jobsGrid}>
          {jobs?.map((job, index) => (
            <div key={index} className={styles.jobCard}>
              <div className={styles.cardHeader}>
                <h4 className={styles.cardHeader_name}>{job.title}</h4>
                <p className={styles.cardHeader_size}>
                  Size: {job.companyInfo?.companySize}
                </p>
              </div>
              <div className={styles.cardBody}>
                <p className={styles.cardBody_role}>
                  {job.requirements?.jobCategory}
                </p>
                <div className={styles.requirement}>
                  <img
                    className={styles.requirement_icon}
                    src={require('../../assets/images/salary.png')}
                    alt=""
                  />
                  <span className={styles.requirement_title}>Salary</span>
                  <span className={styles.requirement_value}>
                    {job.requirements?.salary} SEK/MON
                  </span>
                </div>
                <div className={styles.requirement}>
                  <img
                    className={styles.requirement_icon}
                    src={require('../../assets/images/location.png')}
                    alt=""
                  />
                  <span className={styles.requirement_title}>Location</span>
                  <span className={styles.requirement_value}>
                    {job.requirements?.location}
                  </span>
                </div>
                <div className={styles.requirement}>
                  <img
                    className={styles.requirement_icon}
                    src={require('../../assets/images/stars.png')}
                    alt=""
                  />
                  <span className={styles.requirement_title}>Experience</span>
                  <span className={styles.requirement_value}>
                    {job.requirements?.experience} years
                  </span>
                </div>

                <div className={styles.tech}>
                  {job.tech.map(
                    (item, index) =>
                      index < 6 && (
                        <span key={index} className={styles.tech_item}>
                          {item}
                        </span>
                      )
                  )}
                </div>

                <NavLink to={`/job/${job._id}`} className={styles.cardBtn}>
                  <img
                    className={styles.cardBtn_icon}
                    src={require('../../assets/images/eye-icon.png')}
                    alt=""
                  />
                  <span className={styles.cardBtn_text}>View details</span>
                </NavLink>
              </div>
            </div>
          ))}
        </section>
      </section>
      <footer className={styles.pageFooter}>
        <button
          disabled={page === 1}
          className={styles.pageFooter_btn}
          onClick={handlePrevious}
        >
          Previous
        </button>
        <p className={styles.pageFooter_pages}>
          {page}/{pageCount}
        </p>
        <button
          disabled={page === pageCount}
          className={styles.pageFooter_btn}
          onClick={handleNext}
        >
          Next
        </button>
      </footer>
    </UserLayout>
  );
};

export default Jobs;
